import React from "react";
import { BackImage } from "C4";

const ThankYouView = () => {
  const test = "";

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get("mobile")) {
    mobile = true;
  }

  return (
    <div className="thankYouView">
      <BackImage />
      <div className="thankYouView__wrapper">
        <div className="thankYouView__wrapper--header">
          <h1>Thank you!</h1>
          <img
            src="https://s3.amazonaws.com/developertool/1464/logo.png"
            alt="Florida's Paradise Coast Expert"
          />
        </div>
        <p>
          <b>Congratulations</b>, your booking has been received and sent to the
          campaign supervisor for verification.
        </p>
      </div>
      {mobile && (
        <style>
          {
            "\
    .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; } .thankYouView__wrapper { margin-top: 5rem !important; }"
          }
        </style>
      )}
    </div>
  );
};

export default ThankYouView;
